import gql from 'graphql-tag';
export default gql`
  mutation sendRequestCallback($payload: RequestCallbackInput!) {
    sendRequestCallback(payload: $payload) {
      status
      message
    }
  }
`;
